module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-pages",
    style: ({
      backgroundImage: 'url(' + _vm.props.bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "hero-pages__overlay"
  }), _c('div', {
    staticClass: "hero-pages__container"
  }, [(_vm.propstitle.title.rendered) ? _c('h1', {
    staticClass: "hero-pages__title",
    domProps: {
      "innerHTML": _vm._s(_vm.propstitle.title.rendered)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero-pages__subnav"
  }, _vm._l((_vm.array), function(link, b) {
    return _c('router-link', {
      key: b,
      staticClass: "hero-pages__link",
      attrs: {
        "to": link.path
      }
    }, [_c('span', [_vm._v(_vm._s(link.name))])])
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e86edf5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-blog/hero-blog.pug
// module id = 712
// module chunks = 1